export const INBOXES_REQUEST = 'INBOXES_REQUEST',
      SELECT_INBOX = 'SELECT_INBOX',
      RECEIVE_UPDATED_INBOX = 'RECEIVE_UPDATED_INBOX'
